import { z } from 'zod';

import { ShiftTypes } from '~modules/tabel/interfaces/shift-types';
import { WorkTimeTypes } from '~modules/tabel/interfaces/work-time-types';

export const EmployeeSchedulePlanDtoScheme = z.object({
	id: z.number().describe('Уникальный идентификатор'),
	schedule_name: z.string().describe('Наименование расписания'),
	user_id: z.number().describe('Идентификатор пользователя'),
	shift_type: z.nativeEnum(ShiftTypes).describe('Вид смены'),
	work_time_type: z.nativeEnum(WorkTimeTypes).describe('Вид рабочего времени'),
	date: z.coerce.date().describe('Плановая дата'),
	start: z.coerce.date().describe('Плановое начало работы'),
	end: z.coerce.date().describe('Плановое окончание работы'),
});

export type EmployeeSchedulePlanDto = z.infer<typeof EmployeeSchedulePlanDtoScheme>;

export const ScheduleCreateDtoScheme = EmployeeSchedulePlanDtoScheme.omit({
	id: true,
}).extend({
	id: z.undefined().optional(),
});

export type ScheduleCreateDto = z.infer<typeof EmployeeSchedulePlanDtoScheme>;
